import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "v-row",
  style: {"margin":"20px"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("定时设置")
const _hoisted_3 = {
  key: 0,
  class: "v-column",
  style: {"justify-content":"space-evenly","flex":"1","text-indent":"4px"}
}
const _hoisted_4 = { class: "v-row" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 定时退出： ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 时 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 分 ")
const _hoisted_8 = { class: "v-row" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 定时关机： ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 时 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 分    强制关机： ")
const _hoisted_12 = {
  key: 1,
  style: {"display":"flex","align-items":"center","flex":"1"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hl_button = _resolveComponent("hl-button")!
  const _component_check_box = _resolveComponent("check-box")!
  const _component_text_field = _resolveComponent("text-field")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_hl_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.timerModal = true))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_modal, {
      width: "50%",
      height: "50%",
      title: "定时设置",
      id: "timer-modal",
      visible: _ctx.timerModal,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.timerModal) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.data.option === -1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_check_box, {
                  modelValue: _ctx.dataOfExit.checked,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataOfExit.checked) = $event)),
                    _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkChanged(0)))
                  ]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_text_field, {
                  type: "number",
                  modelValue: _ctx.dataOfExit.hour,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataOfExit.hour) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_6,
                _createVNode(_component_text_field, {
                  type: "number",
                  modelValue: _ctx.dataOfExit.minute,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataOfExit.minute) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_7
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_check_box, {
                  modelValue: _ctx.dataOfShutdown.checked,
                  "onUpdate:modelValue": [
                    _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataOfShutdown.checked) = $event)),
                    _cache[6] || (_cache[6] = ($event: any) => (_ctx.checkChanged(1)))
                  ]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_text_field, {
                  type: "number",
                  modelValue: _ctx.dataOfShutdown.hour,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dataOfShutdown.hour) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_10,
                _createVNode(_component_text_field, {
                  type: "number",
                  modelValue: _ctx.dataOfShutdown.minute,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dataOfShutdown.minute) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_11,
                _createVNode(_component_check_box, {
                  modelValue: _ctx.dataOfShutdown.force,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dataOfShutdown.force) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, " 将在 " + _toDisplayString(_ctx.data.hour) + " 时" + _toDisplayString(_ctx.data.minute) + " 分 " + _toDisplayString(_ctx.data.second) + " 秒后" + _toDisplayString(_ctx.data.option === 0 ? '退出' : '关机'), 1)),
        _createVNode(_component_hl_button, { onClick: _ctx.handleConfirm }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.data.option === -1 ? '确定' : '取消'), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}